// extracted by mini-css-extract-plugin
module.exports = {"container":"container-118HX","group":"group-p5Ovc","header":"header-1182X","item":"item-DXSL3","item__content":"item__content-3AZXG"};